import ConsoleContainer from "components/Console/Console.container";
import OldConsoleContainer from "components/Console/_Console.container";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";

const ConsolePage = () => {
  const { isOciProduct } = useIsOciProduct();
  // OCI 제품은 이전 콘솔 페이지 사용
  if (isOciProduct) {
    return <OldConsoleContainer />;
  }
  return <ConsoleContainer />;
};

export default ConsolePage;
